import { SocialShare } from '@components/social';

export default SocialShare;
